function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M53.2,13.95H19.6c-2.91,0-5.36,2.17-5.36,5.1v22.63c0,2.95,2.41,5.36,5.36,5.36h33.6c.82,0,1.49-.67,1.49-1.49V15.44c0-.82-.67-1.49-1.49-1.49Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M10.14,20.76h-1.67c-.5,0-.74.49-.74.97v16.07c0,.48.23.97.74.97h1.67c.5,0,.74-.49.74-.97v-16.07c0-.49-.23-.97-.74-.97Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M70,16.12h-.64l-10.4,6.65c-.65.42-1.05,1.14-1.05,1.91v11.6c0,.79.41,1.52,1.08,1.93l9.82,6.04c.36.22.77.34,1.19.34,1.25,0,2.27-1.02,2.27-2.27v-23.93c0-1.25-1.02-2.27-2.27-2.27Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40.14,50.83c-.27-.47-.76-.75-1.3-.75h-5.81c-.54,0-1.03.29-1.3.75l-9.57,16.65c-.64,1.11.16,2.49,1.44,2.49h.06c.59,0,1.14-.31,1.43-.82l8.92-14.97c.1-.17.35-.1.35.1v14.13c0,.92.74,1.66,1.66,1.66s1.66-.74,1.66-1.66v-14.12c0-.19.26-.26.35-.1l8.77,14.95c.3.51.84.83,1.44.83h.02c1.28,0,2.07-1.38,1.44-2.49l-9.57-16.65Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/LiveCasino-active.2ba1d59e.svg";
export { SvgComponent as ReactComponent };